import axios from 'axios';
import i18n from '@/i18n';

export default {
  namespaced: true,

  state: {
    authenticated: false,
    user: null,
    // notifications: [],
    receivedMessages: null,
    sentMessages: null,

    deletedPaymentMethod: false,
  },

  getters: {
    authenticated(state) {
      return state.authenticated;
    },

    user(state) {
      return state.user;
    },

    student(state) {
      return state.user.student;
    },

    teacher(state) {
      return state.user.teacher;
    },

    isTeacher(state) {
      return state.user.user_type === 'teacher';
    },

    isStudent(state) {
      return state.user.user_type === 'student';
    },

    isAdmin(state) {
      return state.user.user_type === 'admin';
    },

    receivedMessages(state) {
      return state.receivedMessages;
    },

    messagesToRead(state) {
      return state.receivedMessages
        ? state.receivedMessages.filter((message) => message.read === 0)
        : [];
    },

    sentMessages(state) {
      return state.sentMessages;
    },

    dashboardPath(state, getters) {
      if (!getters.authenticated) {
        return '/signin';
      }
      if (getters.isAdmin) {
        return '/admin-dashboard';
      }
      if (getters.isTeacher) {
        return '/teacher-dashboard';
      }
      return '/student-dashboard';
    },

    deletedPaymentMethod(state) {
      return state.deletedPaymentMethod;
    },
  },

  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },

    SET_USER(state, value) {
      state.user = value;
    },

    // SET_NOTIFICATIONS(state, notifications) {
    //   state.notifications = notifications;
    // },

    SET_RECEIVED_MESSAGES(state, value) {
      state.receivedMessages = value;
    },

    SET_SENT_MESSAGES(state, value) {
      state.sentMessages = value;
    },

    DELETED_PAYMENT_METHOD(state) {
      state.deletedPaymentMethod = !state.deletedPaymentMethod;
    },
  },

  actions: {
    fetchAuthentication() {
      return this.state;
    },

    async register({ dispatch }, credentials) {
      // await axios.get('/sanctum/csrf-cookie');
      await axios.post('/register', credentials);

      return dispatch('me');
    },

    async registerTeacher({ dispatch }, credentials) {
      // await axios.get('/sanctum/csrf-cookie');
      await axios.post('/api/teachers', credentials);

      return dispatch('teacher');
    },

    async SignIn({ dispatch }, credentials) {
      await axios.get('/sanctum/csrf-cookie');
      await axios.post('/login', credentials);

      return dispatch('me');
    },

    async SignOut({ dispatch }) {
      await axios.post('/logout');

      return dispatch('me');
    },

    me({ commit, dispatch, getters }) {
      return axios
        .get('/api/user')
        .then(async ({ data }) => {
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', data);
          i18n.locale = data.lang;
          if (!getters.isAdmin) {
            await dispatch('notifications/getNotifications', null, { root: true });
            // commit('SET_NOTIFICATIONS', null);
            // commit('SET_NOTIFICATIONS', data.app_notifications);
            dispatch('getReceivedMessages');
            dispatch('getSentMessages');
          }
          dispatch('changeLocale');
        })
        .catch(() => {
          i18n.locale = 'en';
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
          dispatch('changeLocale');
        });
    },

    auth({ commit, getters }) {
      return axios
        .get('/api/user')
        .then((response) => {
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', response.data);
          if (!getters.isAdmin) {
            // commit('SET_NOTIFICATIONS', null);
            // commit('SET_NOTIFICATIONS', response.data.app_notifications);
          }
        })
        .catch(() => {
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
        });
    },

    async changeLocale() {
      axios.defaults.headers.common['Accept-Language'] = i18n.locale;
      const locale = {
        newLocale: i18n.locale,
      };
      await axios.put('/api/locales', locale);
    },

    teacher() {
      return axios
        .get('/api/user')
        .then((response) => {
          console.log(`registrato nuovo docente: ${response.data}`);
        })
        .catch(() => {
          console.log('fallita registrazione');
        });
    },

    /* getNotifications({ commit, state }) {
      commit('SET_NOTIFICATIONS', null);
      const userType = state.user.user_type.toLowerCase();
      return axios.get(`/api/${userType}s/${state.user[userType].id}/notifications`)
      .then(({ data }) => {
        commit('SET_NOTIFICATIONS', data);
      }).catch((errors) => {
        console.log(errors);
      });
    }, */

    getReceivedMessages({ commit, state }) {
      commit('SET_RECEIVED_MESSAGES', null);
      return axios
        .get(`/api/users/${state.user.id}/messages?type=received`)
        .then(({ data }) => {
          commit('SET_RECEIVED_MESSAGES', data);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    getSentMessages({ commit, state }) {
      commit('SET_SENT_MESSAGES', null);
      return axios
        .get(`/api/users/${state.user.id}/messages?type=sent`)
        .then(({ data }) => {
          commit('SET_SENT_MESSAGES', data);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    deletedPaymentMethod({ commit }) {
      commit('DELETED_PAYMENT_METHOD');
    },

    saveTimezone({ state }, timezone) {
      // await axios.get('/sanctum/csrf-cookie');
      return axios.put(`/api/users/${state.user.id}`, { timezone });
    },
  },
};
